/**
 * @name CaptchaInAdvancedSignup.View.js
 * @author Anchor Group : Kalpa
 * @since 2025-02-13
 * @file Add Google Re-Captcha to advanced signup form.
 */
define('CaptchaInAdvancedSignup.View', [
    'captcha_in_advanced_signup.tpl',
    'Backbone',
    'Utils',
    'jQuery',
    'GoogleCaptcha.SS2Model',
], function (
    captcha_in_advanced_signup_tpl,
    Backbone,
    Utils,
    jQuery,
    CaptchaInRegisterSS2Model
) {
    'use strict';
    return Backbone.View.extend({
        template: captcha_in_advanced_signup_tpl,
        validateCaptcha: function () {
            var promise = jQuery.Deferred();
            var response = grecaptcha.getResponse();
            var captchaConfig = this.options.captchaConfig;
            if (response.length == 0) {
                this.showError(Utils.translate('You must verify captcha to signup.'));
                promise.reject();
            } else {
                var model = new CaptchaInRegisterSS2Model();
                var requestData = {
                    secret: captchaConfig.secretKey,
                    apiUrl: captchaConfig.verifyUrl,
                    token: response,
                };
                var self = this;
                model.save(requestData).always(function () {
                    var verified = model.get('success') || false;
                    if (verified == true) {
                        self.hideError();
                        promise.resolve();
                    } else {
                        grecaptcha.reset();
                        self.showError(Utils.translate('You must verify captcha to signup.'));
                        promise.reject();
                    }
                });
            }
            return promise;
        },
        validateCaptchaV3: function(){
            var prom = jQuery.Deferred()
            ,	reCaptchaData = {
                    secret: this.options.captchaConfig.secretKey
                ,	apiUrl: this.options.captchaConfig.verifyUrl
                ,   siteKey: this.options.captchaConfig.siteKey
                }
            ,   self = this;
            
            if(grecaptcha){
                grecaptcha.execute(reCaptchaData['siteKey'], {action: 'signup'})
                .then(function(token){
                    var model = new CaptchaInRegisterSS2Model(reCaptchaData);
                    model.set('token', token);
                    model.save()
                    .always(function(response){
                        if(!!response.success && response.score > 0.5){
                            self.hideError();
                            prom.resolve()
                        }
                        else {
                            self.showError(Utils.translate('Invalid Captcha.'));
                            prom.reject();
                        }
                    });
                });
                return prom;
            }
            return prom.resolve();
        },
        getContext: function getContext() {
            var captchaConfig = this.options.captchaConfig
            ,   reCaptchaVersion = this.options.application.getConfig().get('GoogleCaptcha.reCaptchaVersion');
            return {
                captchaKey: captchaConfig.siteKey,
                captchaApiUrl: captchaConfig.apiUrl,
                isV2: !!(reCaptchaVersion == 'V2')
            };
        },
    });
});
